document.addEventListener('DOMContentLoaded', function () {
	// Sub-nav expand (works on both mobile and desktop)
    var subnavItems = document.querySelectorAll('.has-subnav');
    subnavItems.forEach(function (item) {
        var expand = item.querySelector('.mega-menu__expand');
        var link = item.querySelector('a');

        if (expand) {
            expand.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                item.classList.toggle('is-open');
            });
        }

        if (link && item.querySelector('.mega-menu__sublist')) {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                item.classList.toggle('is-open');
            });
        }
    });

	// Mobile: mega menu and dropdown toggle on click
    var megaMenuItems = document.querySelectorAll('.has-mega-menu, .has-dropdown');

    megaMenuItems.forEach(function (item) {
        var link = item.querySelector(':scope > a');

        if (link) {
            link.addEventListener('click', function (e) {
                if (window.innerWidth < 768) {
                    e.preventDefault();
                    megaMenuItems.forEach(function (other) {
                        if (other !== item) {
                            other.classList.remove('is-active');
                        }
                    });
                    item.classList.toggle('is-active');
                }
            });
        }
    });
});

// For mega menu items and dropdowns on mobile
document.querySelectorAll('.timken-mega-nav .has-mega-menu > a, .timken-mega-nav .has-dropdown > a').forEach(link => {
	link.addEventListener('click', function (e) {
		if (window.innerWidth < 768) { // adjust breakpoint as needed
			e.preventDefault();
			const parent = this.parentElement;

			// Close siblings first
			parent.parentElement.querySelectorAll('.is-active').forEach(el => {
				if (el !== parent) el.classList.remove('is-active');
			});

			// Toggle current item
			parent.classList.toggle('is-active');
		}
	});
});
